import { resolveAssetUrl } from "../../../utils/resolveAssetUrl";
import { useForm } from "../context";

const BannerRight = () => {
  const { checkout, firstItem } = useForm();

  const rightBanner = checkout.styleConfig?.rightBanner;

  if (!rightBanner || Array.isArray(rightBanner) || typeof rightBanner !== 'string') {
    return null;
  }

  return (
    <div className='w-full sm:w-100 max-w-full'>
      <img loading='lazy' src={resolveAssetUrl(rightBanner)} alt={firstItem?.description} className='object-cover w-full rounded-lg' />
    </div>
  );
};

export default BannerRight;
